export default "__VITE_ASSET__BXuulWa___"